import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { CompanyHelper } from 'src/app/helpers/company-helper';
import { CollectKeyFromOption } from 'src/app/helpers/interfaces/collect-key-from-option';
import ProjectContact from 'src/app/model/company/projectContact';
import { Project } from 'src/app/model/project/project';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'collect-key-from-selector',
  templateUrl: './collect-key-from-selector.component.html',
  styleUrls: ['./collect-key-from-selector.component.scss']
})
export class CollectKeyFromSelectorComponent extends SubscriptionBasedComponent
  implements OnInit, OnChanges {
  @Input()
  projectPlacement: ProjectPlacement;

  @Input()
  project: Project;

  @Input()
  projectContacts: ProjectContact[];

  @Output()
  collectKeyFromChanged = new EventEmitter<never>();

  init: boolean = false;

  private availableProjectContacts: ProjectContact[];

  collectKeyFromOptions: CollectKeyFromOption[];
  selectedOption: CollectKeyFromOption;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit(): void {
    this.reinitialize();

    this.initializeSubscriptions();

    this.init = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.availableProjectContacts != null &&
      !changes.availableProjectContacts.isFirstChange()
    ) {
      this.reinitialize();
    }
  }

  private reinitialize(): void {
    this.calculateAvailableProjectContacts();
    this.calculateOptions();
    this.calculateSelectedOption();
  }

  private calculateAvailableProjectContacts(): void {
    this.availableProjectContacts =
      this.projectContacts != null
        ? this.projectContacts
        : this.project != null &&
          CollectionHelper.isPopulated(this.project.projectContacts)
        ? this.project.projectContacts
        : null;
  }

  private calculateOptions(): void {
    this.collectKeyFromOptions = !CollectionHelper.isPopulated(
      this.availableProjectContacts
    )
      ? []
      : CompanyHelper.constructCollectKeyOptions(this.availableProjectContacts);
  }

  private calculateSelectedOption(): void {
    if (
      !CollectionHelper.isPopulated(this.collectKeyFromOptions) ||
      this.projectPlacement.collectKeyFrom == null
    ) {
      this.selectedOption = null;
    } else if (this.projectPlacement.collectKeyFrom === -1) {
      this.selectedOption = this.collectKeyFromOptions.find(o => o.id === -1);
    } else {
      this.selectedOption = this.collectKeyFromOptions.find(
        o =>
          o.id === this.projectPlacement.collectKeyFrom &&
          o.addressType === this.projectPlacement.collectKeyAddressType
      );
    }
  }

  private initializeSubscriptions(): void {
    this.addSubscription(
      this.projectDisplayObservableService.getProjectContactsChangedSubscribable(),
      () => {
        this.reinitialize();
      }
    );
  }

  selectedOptionChanged(): void {
    this.projectPlacement.collectKeyFrom = this.selectedOption.id;
    this.projectPlacement.collectKeyAddressType = this.selectedOption.addressType;
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
    this.collectKeyFromChanged.emit();
  }

  compareOptions(o1: CollectKeyFromOption, o2: CollectKeyFromOption): boolean {
    if (o1 == null && o2 == null) {
      return true;
    }
    if (o1 == null && o2 != null) {
      return false;
    }
    if (o1 != null && o2 == null) {
      return false;
    }
    return (
      (o1.id === -1 && o2.id === -1) ||
      (o1.id === o2.id && o1.addressType === o2.addressType)
    );
  }
}
